import layout from "@app/styles/_layout.module.scss";

export const GRID_WIDTH = 8; // in columns

export const GRID_MARGIN = [parseInt(layout.spacerM), parseInt(layout.spacerM)] as [number, number];

export const GRID_ROW_HEIGHT = 75;
